"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectInputSchema = exports.projectSchema = exports.projectStatusSchema = exports.PROJECT_STATUSES = void 0;
const zod_1 = require("zod");
const common_js_1 = require("./common.js");
const organisation_js_1 = require("./organisation.js");
exports.PROJECT_STATUSES = ['akquise', 'aktiv', 'abgeschlossen', 'archiviert'];
exports.projectStatusSchema = zod_1.z.enum(exports.PROJECT_STATUSES);
exports.projectSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    number: common_js_1.textSchema,
    name: common_js_1.textSchema,
    clientName: common_js_1.textSchema.nullable(),
    projectManagerId: common_js_1.idSchema,
    companyId: common_js_1.idSchema.nullable(),
    status: exports.projectStatusSchema,
    fee: common_js_1.moneySchema.nullable(),
    completedAt: common_js_1.timestampSchema.nullable(),
    version: zod_1.z.number().int().nonnegative(),
});
/** AC-201 requires only number, name, lead and status when creating a project. */
exports.projectInputSchema = zod_1.z.strictObject({
    number: common_js_1.textSchema,
    name: common_js_1.textSchema,
    projectManagerId: common_js_1.idSchema,
    status: exports.projectStatusSchema,
    clientName: common_js_1.textSchema.optional(),
    companyId: common_js_1.idSchema.optional(),
    fee: common_js_1.moneySchema.optional(),
});
//# sourceMappingURL=projects.js.map